/**
 * Administration Module Sidebar
 * Secondary navigation for Administration module
 */

import React, { useState, useEffect } from 'react';
import { Layout, Menu } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  TeamOutlined,
  SafetyOutlined,
  FileTextOutlined,
  AuditOutlined,
} from '@ant-design/icons';
import { spacing, colors } from '../../theme/designTokens';

const { Sider } = Layout;

const getMenuItems = () => [
  {
    key: '/administration/users',
    icon: <TeamOutlined />,
    label: 'Users',
  },
  {
    key: '/administration/roles',
    icon: <SafetyOutlined />,
    label: 'Roles',
  },
  {
    key: '/administration/document-settings',
    icon: <FileTextOutlined />,
    label: 'Document Settings',
  },
  {
    key: '/administration/audit-trail',
    icon: <AuditOutlined />,
    label: 'Audit Trail',
  },
];

function AdministrationSidebar({ onClose, primaryExpanded }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1200);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const selectedKey = location.pathname;
  const isOverlayMode = isSmallScreen;

  const handleMenuClick = ({ key }) => {
    navigate(key);
    if (onClose) {
      onClose();
    }
  };

  return (
    <>
      {isOverlayMode && (
        <div
          onClick={onClose}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1000,
            transition: 'opacity 0.24s',
          }}
        />
      )}

      {/* Click area above sidebar to close */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          left: primaryExpanded ? 200 : 56,
          top: 0,
          width: 240,
          height: '207px',
          zIndex: 40,
          cursor: 'pointer',
        }}
      />

      <Sider
        width={240}
        trigger={null}
        style={{
          height: 'calc(100vh - 207px)',
          position: 'fixed',
          left: isOverlayMode ? 0 : (primaryExpanded ? 200 : 56),
          top: '207px',
          bottom: 0,
          boxShadow: isOverlayMode ? '4px 0 16px rgba(0, 0, 0, 0.3)' : 'none',
          zIndex: isOverlayMode ? 1001 : 40,
          backgroundColor: colors.sidebar.secondary,
          borderRight: `1px solid ${colors.sidebar.divider}`,
          transition: 'left 0.3s ease-in-out',
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
        }}
        theme="dark"
      >
      <div
        className="trustgrid-sidebar-scroll"
        style={{
          flex: 1,
          overflowY: 'auto',
          overflowX: 'hidden',
          minHeight: 0,
          paddingTop: '16px',
          paddingBottom: '16px',
        }}
      >
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          onClick={handleMenuClick}
          items={getMenuItems()}
          theme="dark"
          style={{
            borderRight: 0,
            paddingTop: 0,
            paddingBottom: spacing.xxl,
            paddingLeft: '16px',
            backgroundColor: 'transparent',
            fontSize: 14,
          }}
          className="trustgrid-panel-menu"
        />
      </div>
    </Sider>
    </>
  );
}

export default AdministrationSidebar;
